(function($)
{
	$.Redactor.prototype.customvariables = function()
	{
		return {
			init: function()
			{
				var items = Array.isArray(Statamic.customRedactorVariables) ? Statamic.customRedactorVariables.map(function(item) {
					return {
						label: item.label,
						tag: item.tag,
					};
				}) : [];

				this.customvariables.template = $('<ul id="redactor-modal-list">');

				for (var i = 0; i < items.length; i++)
				{
					var li = $('<li>');
					var a = $('<a href="#" class="redactor-clips-link">')
						.text(items[i].label)
						.attr('data-label', items[i].label)
						.attr('data-tag', items[i].tag);

					li.append(a);
					this.customvariables.template.append(li);
				}

				this.modal.addTemplate('customvariables', '<div class="modal-section">' + this.utils.getOuterHtml(this.customvariables.template) + '</div>');

				var button = this.button.add('customvariables', 'Variables');
				this.button.setAwesome('customvariables','fa-puzzle-piece');

				this.button.addCallback(button, this.customvariables.show);

			},
			show: function()
			{
				this.modal.load('customvariables', 'Insert Custom Variable', 500);

				$('#redactor-modal-list').find('.redactor-clips-link').each($.proxy(this.customvariables.load, this));

				this.modal.show();
			},
			load: function(i,s)
			{
				$(s).on('click', $.proxy(function(e)
				{
					e.preventDefault();

					var sel = $(s);
					var tag = sel.attr('data-tag');
					var label = sel.attr('data-label');

					this.customvariables.insert(tag, label);

				}, this));
			},
			insert: function(tag, label)
			{

                var tagNode = $('<span />')
                    .addClass('custom-variable')
                    .attr('data-custom-variable', tag)
                    .attr('contenteditable', 'false')
                    .html(label);

				this.buffer.set();
				this.insert.node(tagNode);
				this.modal.close();
				// this.caret.setAfter(tagNode);

                this.code.sync();
			}
		};
	};
})(jQuery);